import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GeneralService } from "../services/general.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-marque",
  templateUrl: "./marque.component.html",
  styleUrls: ["./marque.component.scss"],
})
export class MarqueComponent implements OnInit {
  // ! image in Serveur
  constructor(private router: Router, public generalService: GeneralService) {}

  dataSource = new MatTableDataSource([]);
  displayedColumns = ["Marque_Icon", "Marque_Label"];
  marque = { Marque_Code: null, Marque_Label: null, Marque_Icon: null };
  disabledBtnAjouter: boolean = false;
  disabledBtnsupprimer: boolean = false;
  enregistrementTerminer: boolean = true;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else {
      this.getInitDoc();
      this.getMarques();
    }
  }
  getMarques() {
    this.generalService
      .rechercheTable(this.generalService.urlListeMarques)
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data);
      });
  }
  importer() {
    document.getElementById("input_30_30").click();
  }
  initDoc;
  getInitDoc() {
    this.generalService
      .rechercheTable(this.generalService.urlAvtDoc)
      .subscribe((doc) => {
        this.initDoc = doc;
      });
  }
  file;
  imageToUpload = { base64: null, name: "", code: "" };
  onChangeImagefile(fileInput) {
    this.file = fileInput.target.files[0];
    var reader2 = new FileReader();
    reader2.onload = (e) => {
      var image = new Image();
      image.src = reader2.result.toString();
      var imagee = document.getElementById("img_30_30");
      imagee.setAttribute("src", image.src);
      image.onload = (ev) => {
        this.imageToUpload.base64 = this.generalService.redimentionnerImage(
          image,
          1000,
          370,
          80
        );
        this.imageToUpload.name = fileInput.target.files[0].name;
      };
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }
  addFiles() {
    var File_Text = this.file.name;
    var doc = this.generalService.clone(this.initDoc);
    doc.files[0].File_Parent = "ecImage";
    doc.files[0].File_Content = this.imageToUpload.base64;
    doc.files[0].File_Text = null;
    doc.files[0].File_Key = this.imageToUpload.code;
    doc.files[0].File_Type = "marque";
    doc.files[0].File_Groupe = null;
    doc.files[0].File_Lien = null;
    doc.files[0].File_Class = null;
    if (this.generalService.useDataBaseToSaveImage == 0) {
      this.generalService.uploadFile2(this.file, File_Text).subscribe(
        (data1) => {
          doc.files[0].File_Content = data1["fileName"];
          this.lastKey = doc.files[0].File_Content;
          this.generalService.enregisterTable(doc).subscribe(
            (data) => {
              this.ajouter();
              // this.generalService.dialogSuccess(
              //   "image " + taille + " enregisté",
              //   true
              // );
              this.enregistrementTerminer = true;
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                "image " + " non enregisté",
                false
              );
            }
          );
        },
        (err) => {
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess(" non enregisté", false);
        }
      );
    }
  }
  lastKey;
  ajouter() {
    if (this.marque.Marque_Label != "" && this.marque.Marque_Icon != "") {
      var ds;
      this.disabledBtnAjouter = true;
      this.generalService
        .rechercheTable(this.generalService.urlMarqueArticle)
        .subscribe((data) => {
          ds = data;
          ds.ecMarque[0].Marque_Label = this.marque.Marque_Label;
          ds.ecMarque[0].Marque_Icon = this.lastKey;
          // ds.ecMarque[0].Marque_Code = this.marque.Marque_Code;
          this.generalService.enregisterTable(ds).subscribe(
            (d) => {
              this.lastKey = null;
              this.imageToUpload = { base64: null, name: "", code: "" };
              this.disabledBtnAjouter = false;
              var imagee = document.getElementById("img_30_30");
              imagee.setAttribute("src", null);
              this.marque.Marque_Label = null;
              this.generalService.dialogSuccess("Enregistrer", true);
              this.getMarques();
            },
            (err) => {
              this.generalService.dialogSuccess("non enregistrer", false);
            }
          );
        });
    } else
      this.generalService.dialogSuccess(
        "Veuillez remplir tous les champs",
        false
      );
  }
  selectRowGroupe(event, row) {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function (el) {
      el.style = "";
    });
    event.currentTarget.style = "background-color: #a0bdf3;";
    this.marque.Marque_Code = row.Marque_Code;
    this.marque.Marque_Icon = row.Marque_Icon;
    this.marque.Marque_Label = row.Marque_Label;
    var image = document.getElementById("img_30_30");
    image.setAttribute(
      "src",
      this.generalService.base_url + "images/" + row.Marque_Icon
    );
  }

  modifier() {
    if (this.marque.Marque_Label != "" && this.marque.Marque_Icon != "") {
      var ds;
      this.disabledBtnAjouter = true;
      this.generalService
        .rechercheTable(
          this.generalService.urlMarqueArticle +
            "&val=" +
            this.marque.Marque_Code
        )
        .subscribe((data) => {
          ds = data;
          ds.ecMarque[0].Marque_Label = this.marque.Marque_Label;
          ds.ecMarque[0].Marque_Icon = this.marque.Marque_Icon;
          this.generalService.enregisterTable(ds).subscribe(
            (d) => {
              this.disabledBtnAjouter = false;
              this.generalService.dialogSuccess("Enregistrer", true);
              this.getMarques();
            },
            (err) => {
              this.generalService.dialogSuccess("non enregistrer", false);
            }
          );
        });
    } else
      this.generalService.dialogSuccess(
        "Veuillez remplir tous les champs",
        false
      );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  supprimer() {
    if (this.marque.Marque_Code != null) {
      var deleteFn = this.generalService.supprimer(
        this.marque.Marque_Code,
        "ecMarque"
      );
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.disabledBtnsupprimer = true;
        deleteFn.subscribe(
          (data) => {
            this.getMarques();
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.disabledBtnsupprimer = false;
            this.marque.Marque_Code = null;
            this.marque.Marque_Icon = null;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.disabledBtnsupprimer = false;
          }
        );
      }
    }
  }

  // ! image in data base
  //   constructor(private router: Router, public generalService: GeneralService) {}

  //   dataSource = new MatTableDataSource([]);
  //   displayedColumns = ["Marque_Icon", "Marque_Label"];
  //   marque = { Marque_Code: null, Marque_Label: null, Marque_Icon: null };
  //   disabledBtnAjouter: boolean = false;
  //   disabledBtnsupprimer: boolean = false;
  //   enregistrementTerminer: boolean = true;
  //   ngOnInit() {
  //     if (this.generalService.userConnecter == "") {
  //       this.router.navigate([""]);
  //     } else this.getMarques();
  //   }
  //   getMarques() {
  //     this.generalService
  //       .rechercheTable(this.generalService.urlListeMarques)
  //       .subscribe((data) => {
  //         this.dataSource = new MatTableDataSource(data);
  //       });
  //   }
  //   importer() {
  //     document.getElementById("input_30_30").click();
  //   }
  //   onChangeImagefile(fileInput) {
  //     var reader2 = new FileReader();
  //     var src;
  //     reader2.onload = (e) => {
  //       src = reader2.result;
  //       this.marque.Marque_Icon = src;
  //       var image = document.getElementById("img_30_30");
  //       image.setAttribute("src", src);
  //     };
  //     reader2.readAsDataURL(fileInput.target.files[0]);
  //   }
  //   ajouter() {
  //     if (this.marque.Marque_Label != "" && this.marque.Marque_Icon != "") {
  //       var ds;
  //       this.disabledBtnAjouter = true;
  //       this.generalService
  //         .rechercheTable(this.generalService.urlMarqueArticle)
  //         .subscribe((data) => {
  //           ds = data;
  //           ds.ecMarque[0].Marque_Label = this.marque.Marque_Label;
  //           ds.ecMarque[0].Marque_Icon = this.marque.Marque_Icon;
  //           // ds.ecMarque[0].Marque_Code = this.marque.Marque_Code;
  //           this.generalService.enregisterTable(ds).subscribe(
  //             (d) => {
  //               this.disabledBtnAjouter = false;
  //               this.generalService.dialogSuccess("Enregistrer", true);
  //               this.getMarques();
  //             },
  //             (err) => {
  //               this.generalService.dialogSuccess("non enregistrer", false);
  //             }
  //           );
  //         });
  //     } else
  //       this.generalService.dialogSuccess(
  //         "Veuillez remplir tous les champs",
  //         false
  //       );
  //   }
  //   selectRowGroupe(event, row) {
  //     var els = document.getElementsByClassName("mat-row");
  //     Array.prototype.forEach.call(els, function (el) {
  //       el.style = "";
  //     });
  //     event.currentTarget.style = "background-color: #a0bdf3;";
  //     this.marque.Marque_Code = row.Marque_Code;
  //     this.marque.Marque_Icon = row.Marque_Icon;
  //     this.marque.Marque_Label = row.Marque_Label;
  //     var image = document.getElementById("img_30_30");
  //     image.setAttribute("src", row.Marque_Icon);
  //   }

  //   modifier() {
  //     if (this.marque.Marque_Label != "" && this.marque.Marque_Icon != "") {
  //       var ds;
  //       this.disabledBtnAjouter = true;
  //       this.generalService
  //         .rechercheTable(
  //           this.generalService.urlMarqueArticle +
  //             "&val=" +
  //             this.marque.Marque_Code
  //         )
  //         .subscribe((data) => {
  //           ds = data;
  //           ds.ecMarque[0].Marque_Label = this.marque.Marque_Label;
  //           ds.ecMarque[0].Marque_Icon = this.marque.Marque_Icon;
  //           this.generalService.enregisterTable(ds).subscribe(
  //             (d) => {
  //               this.disabledBtnAjouter = false;
  //               this.generalService.dialogSuccess("Enregistrer", true);
  //               this.getMarques();
  //             },
  //             (err) => {
  //               this.generalService.dialogSuccess("non enregistrer", false);
  //             }
  //           );
  //         });
  //     } else
  //       this.generalService.dialogSuccess(
  //         "Veuillez remplir tous les champs",
  //         false
  //       );
  //   }

  //   applyFilter(filterValue: string) {
  //     this.dataSource.filter = filterValue.trim().toLowerCase();
  //   }
  //   supprimer() {
  //     if (this.marque.Marque_Code != null) {
  //       var deleteFn = this.generalService.supprimer(
  //         this.marque.Marque_Code,
  //         "ecMarque"
  //       );
  //       if (deleteFn != null) {
  //         this.enregistrementTerminer = false;
  //         this.disabledBtnsupprimer = true;
  //         deleteFn.subscribe(
  //           (data) => {
  //             this.getMarques();
  //             this.generalService.dialogSuccess("Elément supprimer", true);
  //             this.enregistrementTerminer = true;
  //             this.disabledBtnsupprimer = false;
  //           },
  //           (error) => {
  //             this.generalService.dialogSuccess("Elément non supprimé", false);
  //             this.enregistrementTerminer = true;
  //             this.disabledBtnsupprimer = false;
  //           }
  //         );
  //       }
  //     }
  //   }
}
